// src/stone/illustrations/StonjiPillarCallIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPillarCallIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M6.737 14.013v-1.788c0-4.854 3.985-8.806 8.881-8.806h1.796c4.898 0 8.882 3.952 8.882 8.806v1.788h1.836v-1.788c0-5.86-4.808-10.625-10.718-10.625h-1.796c-5.91 0-10.717 4.765-10.717 10.625v1.788z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "m27.999 10.653-1.126-.085c-2.383-.18-4.46 1.619-4.64 4.02l-.283 3.796c-.179 2.4 1.608 4.493 3.99 4.673l1.127.085c2.382.181 4.46-1.619 4.639-4.019l.283-3.797c.18-2.4-1.607-4.492-3.99-4.673M4.944 23.08l1.065-.081c2.383-.18 4.17-2.273 3.99-4.673l-.291-3.91c-.18-2.401-2.257-4.2-4.64-4.02l-1.065.08c-2.383.181-4.17 2.273-3.99 4.673l.292 3.911c.18 2.4 2.256 4.2 4.64 4.02"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M25.71 21.529c-.415 3.91-3.662 6.883-7.52 6.978l.052 1.135q.083 0 .165-.002c4.393-.2 8.053-3.664 8.444-8.161l-1.138.052z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#008E5A",
          d: "M5.973 14.013v-1.788c0-4.854 3.92-8.806 8.742-8.806h1.766c4.82 0 8.742 3.952 8.742 8.806v1.788h1.806v-1.788C27.03 6.365 22.3 1.6 16.481 1.6h-1.766C8.898 1.6 4.167 6.365 4.167 12.225v1.788zM25.266 21.248c-.59 3.887-3.97 6.71-7.827 6.628v1.136q.082.002.164.004c4.397 0 8.21-3.294 8.8-7.768h-1.14z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "m17.895 27.64-1.117.085a1.257 1.257 0 0 0-1.154 1.351l.012.157a1.254 1.254 0 0 0 1.342 1.162l1.116-.085a1.257 1.257 0 0 0 1.154-1.351l-.012-.157a1.254 1.254 0 0 0-1.34-1.162"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00D483",
          d: "m17.721 27.175-1.117.085a1.257 1.257 0 0 0-1.154 1.351l.012.157a1.254 1.254 0 0 0 1.341 1.162l1.117-.085a1.257 1.257 0 0 0 1.154-1.35l-.012-.157a1.254 1.254 0 0 0-1.341-1.163"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M24.701 9.23s.28.743.398 1.512c0 0 .948-.334 1.87-.234 0 0-.154-.708-.563-1.92l-1.703.641z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M24.701 9.182a.03.03 0 0 1-.027-.019c-.004-.013 0-.03.016-.036l1.172-.48-1.154.33c-.013.004-.03-.005-.034-.018a.03.03 0 0 1 .016-.037l1.42-.557c.014-.005.032 0 .037.016.004.014 0 .032-.016.036l-.863.34 1.075-.308c.014-.002.03.005.034.018.004.014 0 .03-.016.037l-.878.36.912-.303c.016-.005.032.002.036.018.005.016-.002.032-.018.036l-1.703.564h-.009zM24.837 22.872s.506.196 1.158.235l-.302.84-1.143-.422.284-.655zM4.307 10.487s1.02.098 1.77.376l.337-1.402-1.737-.507s-.282.864-.37 1.533M19.245 28.894s-.009-.637-.363-1.121c0 0 .169.245.196.764.027.518.167.357.167.357"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M19.252 29.025h-.002c-.016 0-.027-.016-.025-.032 0-.004.052-.477-.228-1.096-.007-.014 0-.03.011-.036.011-.007.03-.003.038.009.01.011.2.3.34.853.004.016-.005.03-.021.034s-.032-.005-.034-.02a4 4 0 0 0-.106-.353c.086.364.06.603.058.616 0 .014-.013.025-.027.025zM6.599 22.911s-.707.141-1.656.193c-.948.053-.14-1.34-.14-1.34l1.796 1.15zM27.74 23.14l-1.697.092.083-.119s.17-.002.43-.009a31 31 0 0 1 1.185.037M29.225 10.933s-.922-.38-2.498-.444c0 0 1.15.002 2.098.444.948.441.4 0 .4 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00D483",
          d: "M.306 19.082c.18 2.4 2.256 4.2 4.638 4.02s4.168-2.273 3.99-4.674l-.293-3.913c-.18-2.4-2.256-4.2-4.638-4.019-2.382.18-4.168 2.273-3.99 4.673zM30.865 15.172c.179-2.4-1.607-4.492-3.99-4.673-2.382-.18-4.458 1.62-4.637 4.02l-.293 3.913c-.179 2.4 1.607 4.492 3.99 4.673 2.382.18 4.458-1.62 4.638-4.02z"
        }
      )
    ]
  }
);
var StonjiPillarCallIllustration_default = StonjiPillarCallIllustration;

export {
  StonjiPillarCallIllustration,
  StonjiPillarCallIllustration_default
};
